import useTranslation from 'next-translate/useTranslation';
import React, { useEffect, useRef, useState } from 'react';

import alcoholIcon from '@/assets/images/alcohol/alcohol-enki.png';
import AlcoholToolTipCommon from '@/components/alcohol/AlcoholTooltipCommon';

import styles from './index.module.scss';
import { BeveragesFilled } from '@weee-fe/kunlunicon';

interface Props {
  visible: boolean;
  targetEl: React.MutableRefObject<HTMLDivElement>;
}

function AlcoholToolTip(props: Props) {
  const { t } = useTranslation('common');
  const { visible, targetEl } = props;

  return (
    <AlcoholToolTipCommon
      tipWidth={240}
      visible={visible}
      tipStyles={{ zIndex: 500 }}
      arrowStyles={{ zIndex: 500 }}
      tipClassName={styles.tooltipBoxPantry}
      arrowClassName={styles.tooltipBoxPantryArrow}
      tip={
        <div className="text-white">
          <h2 className="text-left flex">
            <div className="bg-root-eggplant-purple-light-1 text-root-eggplant-purple-base-7 rounded-200 px-1 h-4 enki-body-3xs-strong float-left flex items-center">
              <div className="mr-0.5 flex items-center">
                <BeveragesFilled />
              </div>
              <div className="enki-body-3xs-strong" style={{ lineHeight: 'inherit' }}>
                ALCOHOL
              </div>
            </div>
            <span className="enki-body-sm-strong ml-1">{t('alcohol_id_needed')}</span>
          </h2>
          <p className="enki-body-2xs text-left">{t('alcohol_reminder2')}</p>
        </div>
      }
      targetEl={targetEl}
    />
  );
}

export default AlcoholToolTip;
